export class PollQuestionModel {
    $key: string;
    createdBy: string;
    eventId: string;
    pollQuestion: string; //
    pollType: string; //
    position: number;
    options = new Array<string>(); //
    pollId = new Array<string>(); //

    isMandatory: boolean = false; //
    showResult: boolean = false; //
    allowOverwrite: boolean = false;

    isReleased: boolean = false; //Unused in app.

}


// WEBPACK FOOTER //
// /app/src/app/core/models/poll-question.ts